import { useState } from 'react';
import axios from 'axios';
import { AUTHORIZED_URL_PREFIX, REPORTS_URL, AxiosConfig } from '../../Utils/Constants';
import './reports.css';
import LykioButton from "../common/LykioButton";
import Form from 'react-bootstrap/Form';
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import t from '../../Utils/Translation';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ExportReactCSV from './../common/ExportReactCSV';
import friendlyDate from '../../Utils/FriendlyDate';


const Reports = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [ usageReporting, setUsageReporting ] = useState(new Map());
	const [ resultsLoaded, setResultsLoaded ] = useState(false);
	const [ groups, setGroups ] = useState([]);
	const [endDate, setEndDate] = useState(new Date());
	const [startDate, setStartDate] = useState(new Date());
	const [csvFileName, setCsvFileName] = useState('lykio-usage-report')
	const [excelTable, setExcelTable] = useState([]);

	const getUsagePeriodDataHandler = async() => {
		try {
			setIsLoading(true);
			const { data } = await axios.post(
				`${AUTHORIZED_URL_PREFIX}${REPORTS_URL}`,
				{ startDate, endDate },
				AxiosConfig()
			);
			if (data.success === true) {
				setUsageReporting(data.usageReporting);
				setGroups(data.groups);
				setCsvFileName(`lykio-usage-report_${friendlyDate(startDate)}-${friendlyDate(endDate)}`)
				let excel = [];
				data.usageReporting.map((usageReportingItem, i) => {
				excel.push(
					{
						lykio: i+1,
						name: `${usageReportingItem.usage[0].user.firstname} ${usageReportingItem.usage[0].user.lastname}`,
						email: usageReportingItem.user,
						logins: usageReportingItem.logins,
						totalviews: usageReportingItem.usage.length,
						unitviews: usageReportingItem.usage.filter(usage=>usage.unit.type.startsWith('System')).length,
						storyviews: usageReportingItem.usage.filter(usage=>usage.unit.type.startsWith('Story')).length,
						group: data.groups.length>0 && data.groups.filter(group => group._id===usageReportingItem.usage[0].user.group)[0].name,
						department: usageReportingItem.usage[0].user.department ? `${usageReportingItem.usage[0].user.department}` : 'none'
					}
				)})
				setExcelTable(excel);
				setResultsLoaded(true)
				setIsLoading(false);
			}else {
				notify(pleaseRefreshError);
			}
		}catch(error) {
			console.log(error);
			notify(pleaseRefreshError);
		}
	}

	return (
		<div className="lykioccs-main-content">
			{isLoading ? (
				<Loading />
			) : (
				<div className="lykiocss-center lykiocss-margin-top-2em">
					<Container>
					<Row>
						<Col xs={12} md={4}>
							<Form onSubmit={getUsagePeriodDataHandler} style={{minWidth:'18rem'}} className="lykiocss-form lykiocss-form-border">
							<div className='lykiocss-title-light'>{t('Select Usage Period')}</div>
							<Form.Group className="mb-4" controlId="startDate">
								<Form.Label>{t('Start Date')}</Form.Label>
								<DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
							</Form.Group>

							<Form.Group className="mb-4" controlId="endDate">
								<Form.Label>{t('End Date')}</Form.Label>
								<DatePicker selected={endDate} onChange={(date) => setEndDate(date)} />
							</Form.Group>

							<LykioButton onClick={() => getUsagePeriodDataHandler()}>{t('Retrieve Report')}</LykioButton>
							</Form>
						</Col>
						<Col xs={12} md={8}>
						<Form className="lykiocss-form lykiocss-form-size" style={{padding:'0em!important'}}>
						{!resultsLoaded && <div className='lykiocss-title-light lykiocss-center'>{t('Select a period and your results will show up here')}</div>}
						{resultsLoaded &&
						<div className='lykiocss-contrast-text'> 
						<h5 className="lykiocss-center" style={{color:'black',paddingTop:'0.5em'}}>{t('Results for selected period')}</h5>
						<ExportReactCSV csvData={excelTable} fileName={csvFileName} buttonText='Export as CSV'/>
						<div className="table-responsive lykiocss-scrollable-table-450 lykiocss-material-table">
						<TableContainer component={Paper}>
						<Table aria-label="simple table" stickyHeader exportButton={true}>
							<TableHead>
							<TableRow>
								<TableCell>#</TableCell>
								<TableCell>{t("Name")}</TableCell>
								<TableCell>{t("Email")}</TableCell>
								<TableCell>{t("Logins")}</TableCell>
								<TableCell>{t("Total Views")}</TableCell>
								<TableCell>{t("Unit Views")}</TableCell>
								<TableCell>{t("Story Views")}</TableCell>
								<TableCell>{t("Group")}</TableCell>
								<TableCell>{t("Department")}</TableCell>
							</TableRow>
							</TableHead>
							<TableBody>
							{usageReporting.map((usageReportingItem, i) => {return <TableRow key={i}>
								<TableCell scope="row">{i + 1}</TableCell>
								<TableCell>{usageReportingItem.usage[0].user.firstname} {usageReportingItem.usage[0].user.lastname}</TableCell>
								<TableCell>{usageReportingItem.user}</TableCell>
								<TableCell>{usageReportingItem.logins}</TableCell>
								<TableCell>{usageReportingItem.usage.length}</TableCell>
								<TableCell>{usageReportingItem.usage.filter(usage=>usage.unit.type === 'System-Lykio').length}</TableCell>
								<TableCell>{usageReportingItem.usage.filter(usage=>usage.unit.type.startsWith('Story')).length}</TableCell>
								<TableCell>{groups.length>0 && groups.filter(group => group._id===usageReportingItem.usage[0].user.group)[0].name}</TableCell>
								<TableCell>{usageReportingItem.usage[0].user.department ? `${usageReportingItem.usage[0].user.department}` : 'none'} </TableCell>
							</TableRow>})}
							</TableBody>
						</Table>
						</TableContainer>
						</div>
						</div>}
						</Form>
						</Col>
					</Row>
					</Container>
				</div>
			)}
		</div>
	);
};

export default Reports;
